import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import DeleteIcon from '@mui/icons-material/Delete';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDTypography from "common/components/MD/MDTypography";
import MDButton from "common/components/MD/MDButton";
import MDInput from "common/components/MD/MDInput";


//validazione lato client
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

import AuthService from "services/API/Auth/AuthService";
import ExpoPartecipazioniService from "services/API/expo_partecipazioni/ExpoPartecipazioniService";
import { Alert } from "@mui/material";
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";



function CaricaFile({ id_richiesta, modulo, filtra }) {


  


    async function vedi_modulo(idModulo) {
        if (AuthService.isTokenOk()) {
            ExpoPartecipazioniService.download_pdf_modulo(idModulo)
                .then(response => {

                    return response.data;
                })
                .then(blob => {

                    var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
                    var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
                    var url = URL.createObjectURL(blobb);
                    var a = document.createElement('a');
                    a.href = url;
                    a.target = "_blank";

                    a.download = modulo.nome_file;


                    document.body.appendChild(a); // append the element to the dom
                    a.click();
                    a.remove(); // afterwards, remove the element  
                })
                .catch(error => {
                    console.error(error);
                });


        }

    }



    /* ----------------------------VALIDAZIONE E SALVATAGGIO----------------------------------------------------------------------- */


    const validationSchema = Yup.object().shape({
        pdf_modulo: Yup.mixed()
            .required("Devi caricare un file")
            .test("fileSize", "Il file è troppo grande o non c'è!", (file) => {
                //if u want to allow only certain file sizes
                return file && file[0] && file[0].size <= 2000000;
            })

    });



    /* ----------------------------SALVATAGGIO E REGISTRAZIONE------------------------------------------------- */



    const {
        register, //register inputs
        reset, setValue, control,
        handleSubmit,//handle form submit
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });
    const [error, setError] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [submitted, setSubmitted] = useState(false);


    const inserisci = (formData) => {
        if (AuthService.isTokenOk()) {
            setError(null);

            var data = {
                id_richiesta: id_richiesta,
                id_utente: AuthService.getCurrentUser().id,
                nome_modulo: modulo.nome_modulo,
                file_allegato: formData.pdf_modulo,
                id_modello: modulo.modello.idFile,

            };

            // if (modo === 'edit') {
            ExpoPartecipazioniService.invia_moduli(id_richiesta, data)
                .then(response => {
                    handleResponse(response, 'SENT');
                })
                .catch(errore => {
                    handleError(errore);
                });
            //   }

        }
    }

    function handleResponse(response, op) {
        // console.log(response.data);
        setSubmitted(true);
      
       // Debounce: aspetta 2 secondi dopo l'ultima digitazione
    const debounceTimer = setTimeout(() => {
  setSubmitted(false);
    filtra();
   
    }, 2000);

    // Pulisci il timer precedente
    return () => clearTimeout(debounceTimer);

    }


    function handleError(error) {
        setError(error);
        console.log("ERRORE" + error);
        console.log(error.code);

        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log("ERROR:RESPONSE" + error.response.data);
            setErrorMessage(error.response.data);

        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log("EEROR:REQUEST" + error.request);
            setErrorMessage(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
            setErrorMessage(error.message);
        }

    }

const deleteModulo = (idModulo) => {

      ExpoPartecipazioniService.removeModulo(idModulo)
                       .then(response => {
                          alert("File rimosso correttamente!");
                      
                       })
                       .catch(errore => {
                              console.log(errore);
                            alert("Errore nella rimozione del file !"+errore)
                       });
     filtra();
    
    };





    return (
        <MDBox>
            {(!modulo.id_modulo || modulo.id_modulo == 0) &&
                <MDBox sx={{ display: 'grid', gap: 5 }}>
                    <MDBox sx={{ display: 'grid', gap: 5, gridTemplateColumns: '5fr 2fr' }}>


                        <MDInput
                            type="file"
                            label={modulo.nome_modulo} fullWidth required

                            {...register('pdf_modulo')}
                            name="pdf_modulo" InputLabelProps={{ shrink: true }}

                        />

                        <MDButton variant="outlined" color="success" onClick={handleSubmit(inserisci)} type="submit"  >
                            Carica
                        </MDButton>

                    </MDBox>
                    {
                        errors.pdf_modulo ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.pdf_modulo?.message}</span> : ''
                    }




                    {error !== null &&
                        <Alert color="error"><ErrorOutlineOutlinedIcon fontSize="small" />&nbsp;{errorMessage}</Alert>
                    }
                    {submitted &&
                        <Alert color="success">File caricato con successo</Alert>
                    }
                </MDBox>
            }
            {(modulo.id_modulo != null && modulo.id_modulo != 0) &&
                <MDBox>
                      <MDBox sx={{ display: 'grid', gap: 5, gridTemplateColumns: '5fr 2fr' }}>
                    <MDTypography
                        variant="button"
                        fontWeight="regular"
                        color="text"
                        sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                        onClick={() => vedi_modulo(modulo.id_modulo)}
                    >
                        {modulo.nome_file}
                    </MDTypography>
             
             {(!modulo.protocollato) && 
          <MDButton onClick={() => deleteModulo(modulo.id_modulo)}
            variant="gradient" color="success" 

         
          >
            <DeleteIcon></DeleteIcon>

          </MDButton>
      } 
      </MDBox>

      </MDBox>
            }


        </MDBox>

    );
}

// Setting default values for the props of DefaultInfoCard
CaricaFile.defaultProps = {
    color: "info",
    value: "",
    description: "",
};

// Typechecking props for the DefaultInfoCard
CaricaFile.propTypes = {
    id_partecipazione: PropTypes.number,
    modulo: PropTypes.array,
    filtra: PropTypes.func,
};

export default CaricaFile;
